"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePopulateCatalogueHref;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _AppSettingsProvider = require("./AppSettingsProvider");

function usePopulateCatalogueHref() {
  var locale = (0, _AppSettingsProvider.useAppSettingsLocale)();
  var routeUrl = (0, _AppSettingsProvider.useAppSettingsRouteUrl)();

  var populateCatalogueHref = _react.default.useCallback(function (categories) {
    var isArr = Array.isArray(categories);
    var res = (isArr ? categories : [categories]).map(function (c) {
      return (0, _extends2.default)({}, c, {
        href: routeUrl('catalogue', {
          locale: locale,
          params: {
            pathParts: (c.href || '').split('/').filter(Boolean)
          }
        })
      });
    });
    return isArr ? res : res[0];
  }, [locale, routeUrl]);

  return populateCatalogueHref;
}